export default "__VITE_ASSET__Bz0xde9T__"